"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = MenuList;
var _request = _interopRequireDefault(require("@/plugins/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function MenuList(data) {
  return (0, _request.default)({
    url: '/api/system/menu/list',
    method: 'post',
    data
  });
}